import { APP_ROUTES } from "../constants";
import { LoadingPage } from "../pages/LoadingPage.tsx";
import { WelcomePage } from "../pages/WelcomePage.tsx";
import { LandingPage } from "../pages/LandingPage.tsx";
import { SummaryPage } from "../pages/SummaryPage.tsx";
import { AddCardPage } from "../pages/AddCardPage.tsx";
import { BillingAddressPage } from "../pages/BillingAddressPage.tsx";
import { AddCardProcessingPage } from "../pages/AddCardProcessingPage.tsx";
import { CipPage } from "../pages/CipPage.tsx";
import { SendingMoneyPage } from "../pages/SendingMoneyPage.tsx";
import { CashDepositPage } from "../pages/CashDepositPage.tsx";
import { HowToDepositCashPage } from "../pages/HowToDepositCashPage.tsx";
import { StoresMapPage } from "../pages/StoresMapPage.tsx";
import { SupportPage } from "../pages/SupportPage.tsx";
import { RouteUnavailablePage } from "../pages/RouteUnavailablePage.tsx";
import { LegalPage } from "../pages/LegalPage.tsx";
import { TermDetailPage } from "../pages/TermDetailPage.tsx";
import { ErrorPage } from "../shared/error/pages/ErrorPage";
import { SessionExpiredPage } from "../shared/error/pages/SessionExpiredPage";
import { LinkAlreadyUsedPage } from "../shared/error/pages/LinkAlreadyUsedPage";
import { ServiceUnavailablePage } from "../shared/error/pages/ServiceUnavailablePage";
import { MaintenancePage } from "../shared/error/pages/MaintenancePage";

export type amountFormatterProps = (
  amount: number,
  currency?: string,
  numberFormatOptions?: {
    country?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  }
) => string;

export const amountFormatter: amountFormatterProps = (
  amount,
  currency = "USD",
  {
    country = "en-US",
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = {}
) =>
  new Intl.NumberFormat(country, {
    style: "decimal",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount);

/** Decimal amount + ISO code; USD also includes `$`. */
export function formatLabeledAmount(
  amount: number,
  currency = "USD",
  numberFormatOptions?: {
    country?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  },
): string {
  const formatted = amountFormatter(amount, currency, numberFormatOptions);
  const code = currency.toUpperCase();
  return code === "USD" ? `$${formatted} ${code}` : `${formatted} ${code}`;
}

export interface IAppRoutes {
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: any;
}

export const routesList: IAppRoutes[] = [
  // Magic-link entry: the flow is encoded in the linkId itself
  { path: APP_ROUTES.LOADING_PAGE, Component: LoadingPage },
  { path: "/:linkId", Component: LoadingPage },
  { path: APP_ROUTES.WELCOME_PAGE, Component: WelcomePage },
  { path: APP_ROUTES.LANDING_PAGE, Component: LandingPage },
  { path: APP_ROUTES.SUMMARY_PAGE, Component: SummaryPage },
  { path: APP_ROUTES.ADD_CARD_PAGE, Component: AddCardPage },
  { path: APP_ROUTES.ADD_CARD_ADDRESS_PAGE, Component: BillingAddressPage },
  { path: APP_ROUTES.ADD_CARD_PROCESSING_PAGE, Component: AddCardProcessingPage },
  { path: APP_ROUTES.CIP_PAGE, Component: CipPage },
  { path: APP_ROUTES.SENDING_MONEY_PAGE, Component: SendingMoneyPage },
  { path: APP_ROUTES.CASH_DEPOSIT_PAGE, Component: CashDepositPage },
  { path: APP_ROUTES.HOW_TO_DEPOSIT_CASH_PAGE, Component: HowToDepositCashPage },
  { path: APP_ROUTES.STORES_MAP_PAGE, Component: StoresMapPage },
  { path: APP_ROUTES.SUPPORT_PAGE, Component: SupportPage },
  { path: APP_ROUTES.ROUTE_UNAVAILABLE_PAGE, Component: RouteUnavailablePage },
  { path: APP_ROUTES.LEGAL_PAGE, Component: LegalPage },
  { path: APP_ROUTES.TERM_DETAIL_PAGE, Component: TermDetailPage },
  { path: APP_ROUTES.ERROR_PAGE, Component: ErrorPage },
  { path: APP_ROUTES.SESSION_EXPIRED_PAGE, Component: SessionExpiredPage },
  { path: APP_ROUTES.LINK_ALREADY_USED_PAGE, Component: LinkAlreadyUsedPage },
  {
    path: APP_ROUTES.SERVICE_UNAVAILABLE_PAGE,
    Component: ServiceUnavailablePage,
  },
  {
    path: APP_ROUTES.MAINTENANCE_PAGE,
    Component: MaintenancePage,
  },
];
